import axios from "axios";
import { FETCH_ALL_BRAND_API } from "../Constants/Apis";

export const getBrands = async () => {
  try {
    return axios.get(FETCH_ALL_BRAND_API);
  } catch (e) {
    return console.log(e);
  }
};

export const createBrand = async (payload) => {
  try {
    return axios.post(FETCH_ALL_BRAND_API, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const updateBrand = async (id, payload) => {
  try {
    return axios.put(`${FETCH_ALL_BRAND_API}/${id}`, payload);
  } catch (e) {
    return console.log(e);
  }
};

export const deleteBrand = async (id) => {
  try {
    return axios.delete(`${FETCH_ALL_BRAND_API}/${id}`);
  } catch (e) {
    return console.log(e);
  }
};

